import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreateConsentSolution } from "@/features/consent-solutions";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Route = createFileRoute("/_authorized/consent-solutions/create")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["CONSENT_SOLUTION_CREATE"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <CreateConsentSolution />,
});

export { Route };
